export interface Currency {
  name: string
  code: string
}

export const currencies: Currency[] = [
  { name: 'currency.ars', code: 'ARS' },
  { name: 'currency.bob', code: 'BOB' },
  { name: 'currency.brl', code: 'BRL' },
  { name: 'currency.cad', code: 'CAD' },
  { name: 'currency.clp', code: 'CLP' },
  { name: 'currency.cop', code: 'COP' },
  { name: 'currency.usd', code: 'USD' },
  { name: 'currency.eur', code: 'EUR' },
  { name: 'currency.gyd', code: 'GYD' },
  { name: 'currency.pyg', code: 'PYG' },
  { name: 'currency.pen', code: 'PEN' },
  { name: 'currency.srd', code: 'SRD' },
  { name: 'currency.ttd', code: 'TTD' },
  { name: 'currency.uyu', code: 'UYU' },
  { name: 'currency.ves', code: 'VES' },
  { name: 'currency.fkp', code: 'FKP' },
]
